const PriceSkeleton: React.FC<{ variant: "web" | "mobile" }> = ({
  variant,
}) => {
  if (variant === "mobile") {
    return (
      <div className="flex flex-col animate-pulse">
        <div className="flex items-baseline gap-1">
          <div className="h-5 bg-gray-300 rounded w-20"></div>
        </div>
        <div className="flex items-center gap-1 mt-1">
          <div className="h-4 bg-gray-300 rounded w-[205px]"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3 pb-6 animate-pulse">
      <div className="flex items-center gap-3">
        <div className="h-4 bg-gray-300 rounded w-32"></div>
        <div className="flex items-baseline gap-2">
          <div className="h-6 bg-gray-300 rounded w-24"></div>
          <div className="h-4 bg-gray-300 rounded w-12"></div>
        </div>
      </div>
      <div className="text-left">
        <div className="h-5 bg-gray-300 rounded w-40"></div>
      </div>
    </div>
  );
};

export default PriceSkeleton;
